(function ($, Cobalt, undefined) {
    Cobalt.User = {
        ID: null,
		Preferences: null,
		Ratings: null,
		IsAuthenticated: false,
		EnabledLanguageIDs: [],
        MaxQuoteDepth: 5,
		DefaultLanguageID: null,
		reloadCookies: function () {
			Cobalt.User.userID = Cobalt.User.ID;
			Cobalt.User.username = $.cookie("User.Username");
			var prefs = $.cookie("Preferences", undefined, { skipEncoding: true });
			if (prefs) {
				try {
					prefs = JSON.parse(prefs);
				}
				catch (e) {
					prefs = null;
				}
				if (prefs == null || prefs == "") {
					prefs = {};
				}
			}
			else {
				prefs = {};
				var allCookies = document.cookie.split("; ");
				for (var i = 0; i < allCookies.length; i++) {
					var cookie = allCookies[i];
					if (cookie.startsWith("Preferences.")) {
						var key = cookie.split("=", 1)[0];
						if (key) {
						    if (key !== "Preferences.ForumThreadSeen" && key !== "Preferences.ForumSeen" && key !== "Preferences.ForumThreadCommented") {
								var pref = $.cookie(key, undefined, { skipEncoding: true });
								if (pref) {
									try {
										pref = JSON.parse(pref);
									}
									catch (e) {
										pref = null;
									}
								}
								prefs[key.substring("Preferences.".length)] = pref;
							}
						}
					}
				}
			}
			Cobalt.User.Preferences = prefs;
		},
		dependentScripts: function () { return [{ dependency: Cobalt.Core, name: "Cobalt.Core" }]; },
		initialize: function () {
			Cobalt.User.reloadCookies();
			Cobalt.User.defaultLanguage = $('body').attr('data-user-lang');
			Cobalt.Localization.Main.setCurrentLanguageID(Cobalt.User.getLanguage());
			Cobalt.User.toggleUserContent();

			var entitlementsClicked = false;
			var showEntitlements = function () {
				if (!entitlementsClicked) {
					entitlementsClicked = true;
					var tab = $("#entitlements");
					var url = tab.attr("data-url");
					$.ajax({
						url: url,
						success: function (data) {
							$("#tab-entitlements").html(data);
							Cobalt.triggerHtmlInsert($("#tab-entitlements"));
						},
						dataType: "html",
						type: "GET"
					});
				}
			};
			$("#entitlements").click(showEntitlements);
			setTimeout(function () {
				if ($("#tab-entitlements .loading").is(":visible")) {
					showEntitlements();
				}
			}, 500);

			var subscriptionsClicked = false;
			var showSubscriptionHistory = function (e) {
				if (!subscriptionsClicked) {
					subscriptionsClicked = true;
					var tab = $("#subscription-history");
					var url = tab.attr("data-url");
					$.ajax({
						url: url,
						success: function (data) {
							$("#tab-subscription-history").html(data);
							Cobalt.triggerHtmlInsert($("#tab-subscription-history"));
						},
						dataType: "html",
						type: "GET"
					});
				}
			};
			$("#subscription-history").click(showSubscriptionHistory);
			setTimeout(function () {
				if ($("#tab-subscription-history .loading").is(":visible")) {
					showSubscriptionHistory();
				}
			}, 500);

			var transactionsClicked = false;
			var showTransactionHistory = function (e) {
				if (!transactionsClicked) {
					transactionsClicked = true;
					var tab = $("#transaction-history");
					var url = tab.attr("data-url");
					$.ajax({
						url: url,
						success: function (data) {
							$("#tab-transaction-history").html(data);
							Cobalt.triggerHtmlInsert($("#tab-transaction-history"));
						},
						dataType: "html",
						type: "GET"
					});
				}
			};
			$("#transaction-history").click(showTransactionHistory);
			setTimeout(function () {
				if ($("#tab-transaction-history .loading").is(":visible")) {
					showTransactionHistory();
				}
			}, 500);

			var legacyClicked = false;
			var showLegacySubs = function (e) {
				if (!legacyClicked) {
					legacyClicked = true;
					var tab = $("#legacy-subscription-history");
					var url = tab.attr("data-url");
					$.ajax({
						url: url,
						success: function (data) {
							$("#tab-legacysubscription-history").html(data);
							Cobalt.triggerHtmlInsert($("#tab-legacysubscription-history"));
						},
						dataType: "html",
						type: "GET"
					});
				}
			};
			$("#legacy-subscription-history").click(showLegacySubs);
			setTimeout(function () {
				if ($("#tab-legacysubscription-history .loading").is(":visible")) {
					showLegacySubs();
				}
			}, 500);

			var nonceClicked = false;
			var showNonce = function (e) {
			    if (!nonceClicked) {
			        nonceClicked = true;
			        var tab = $("#nonce-billing-transaction-history");
			        var url = tab.attr("data-url");
			        $.ajax({
			            url: url,
			            success: function (data) {
			                $("#tab-nonce-billing-transaction-history").html(data);
			                Cobalt.triggerHtmlInsert($("#tab-nonce-billing-transaction-history"));
			            },
			            dataType: "html",
			            type: "GET"
			        });
			    }
			};
			$("#nonce-billing-transaction-history").click(showNonce);
			setTimeout(function () {
			    if ($("#tab-nonce-billing-transaction-history .loading").is(":visible")) {
			        showNonce();
			    }
			}, 500);

			var willNotRenameField = $("#field-will-not-rename");
			if (willNotRenameField.length > 0) {
				if (willNotRenameField.is(":checked")) {
					if (newUserNameDiv.length > 0 && confirmUserNameDiv.length > 0) {
						newUserNameDiv.hide();
						newUserNameDiv.find("input").attr("disabled", "disabled");
						confirmUserNameDiv.hide();
						confirmUserNameDiv.find("input").attr("disabled", "disabled");
					}
				}
				willNotRenameField.click(function () {
					var newUserNameDiv = $("#form-field-new-username");
					var confirmUserNameDiv = $("#form-field-confirm-username");
					if ($(this).is(":checked")) {
						if (newUserNameDiv.length > 0 && confirmUserNameDiv.length > 0) {
							newUserNameDiv.hide();
							newUserNameDiv.find("input").attr("disabled", "disabled");
							confirmUserNameDiv.hide();
							confirmUserNameDiv.find("input").attr("disabled", "disabled");
						}
					}
					else {
						if (newUserNameDiv.length > 0 && confirmUserNameDiv.length > 0) {
							newUserNameDiv.show();
							newUserNameDiv.find("input").removeAttr("disabled");
							confirmUserNameDiv.show();
							confirmUserNameDiv.find("input").removeAttr("disabled");
						}
					}
				});
			}

			if ($(".p-user.p-user-a.s_myProfile").length > 0) {
			    Cobalt.runOnHtmlInsert(function() {
			        Cobalt.Warning.handleWarnForm(function(result) {
			            var warningLink = $(".user-action-warn a.modal-link");
			            if (warningLink.length > 0 && warningLink.attr("data-multi-warning") === "false") {
			                warningLink.removeClass("modal-link").attr("href", "/cp/warning-records/" + result.warningRecordID).find("span").text("Warned!");
			                warningLink.unbind("click");
			            }
			        });
			    });
			}
		},
		toggleUserContent: function () {
			$(".toggle-user-visible").each(function (a) {
				var userID = $(this).attr('data-user-id');
				if (userID == Cobalt.User.userID) {
					$(this).show();
				}
				else {
					$(this).hide();
				}
			});
			$(".toggle-user-hidden").each(function (a) {
				var userID = $(this).attr('data-user-id');
				if (userID == Cobalt.User.userID) {
					$(this).hide();
				}
				else {
					$(this).show();
				}
			});
		},
		setLanguage: function (language) {
			if (Cobalt.User.Preferences.Language != language) {
				Cobalt.User.Preferences.Language = language;
				Cobalt.User.savePreferences(true);
				document.location.reload();
			}
		},
		getLanguage: function () {
			if (Cobalt.User.Preferences == undefined || Cobalt.User.Preferences.Language == undefined) {
				return Cobalt.User.defaultLanguage;
			}
			else if (Cobalt.User.EnabledLanguageIDs.indexOf(Cobalt.User.Preferences.Language) == -1) {
				return Cobalt.User.defaultLanguage;
			}
			else {
				return Cobalt.User.Preferences.Language;
			}
		},
		defaultLanguage: null,
		savePreferences: function (important) {
			var options = { domain: Cobalt.Utils.getCurrentDomain(), path: "/", expires: 700, skipEncoding: true };
			$.cookie("Preferences", null, $.extend({}, options));
			for (var key in Cobalt.User.Preferences) {
				if (Cobalt.User.Preferences.hasOwnProperty(key)) {
					var jsonVal = JSON.stringify(Cobalt.User.Preferences[key]);
					$.cookie("Preferences." + key, jsonVal, $.extend({}, options));
				}
			}

			// TODO: even if not important, sometimes we might want to save, e.g. every 10 minutes
			if (important && Cobalt.User.userID) // if we're not logged in, we don't want to bog down the server
			{
				$.ajax({
					url: Cobalt.Routes.Instance.CommonStorePreferences(),
					dataType: "json",
					type: "POST"
				});
			}
		},
		drawLanguageSelection: function () {
			if (Cobalt.User.EnabledLanguageIDs.length <= 1) {
				return;
			}
			var languageList = $('#language-list');
			if (languageList.length == 0) {
				return;
			}
			var languages = Cobalt.Localization.Main.Languages.concat();
			languages.sortBy(function (value) {
				return value.name.toLowerCase();
			});
			$.each(languages, function (i, language) {
				if (Cobalt.User.EnabledLanguageIDs.indexOf(language.id) == -1) {
					return;
				}
				var name = language.localizedName;
				if (name == null) {
					name = language.name;
				} else {
					var phraseID = language.phraseID;
					if (phraseID == null) {
						name = language.name;
					} else {
						var phrase = Cobalt.Localization.Main[phraseID];
						if (typeof phrase == "function") {
							var localizedName = phrase();
							if (localizedName != name) {
								name = "{0} ({1})".format(name, localizedName);
							}
						} else {
							name = language.name;
						}
					}
				}
				language.fullName = name;
				var a = $("<a/>").attr("href", "javascript:;").addClass('lang-select-' + language.code).text(name).click(function () {
					languageList.hide();
					Cobalt.User.setLanguage(language.id);
					document.location = document.location.toString().split("#")[0]; // refresh
					return false;
				});

				languageList.append($("<li/>").append(a));
				if (language.id == Cobalt.User.getLanguage()) {
					$("#language-selected").addClass('lang-select-' + language.code).html($("<span/>").text(name));
				}
			});
			languageList.width($('.language-selector').width() - 2);
			$('#language-selector').hover(
                function () {
                	languageList.stop(true, true).slideDown(100);
                },
                function () {
                	languageList.stop(true, true).slideUp(100);
                }
            );
		}
	};
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.User.js